import cx from 'classnames';
import {type ReactNode, useEffect, useRef, useState} from 'react';

import './OverlayContentWrapper.sass';

type OverlayContentWrapperProps = {
  children: ReactNode;
  footer?: ReactNode;
  contentClassName?: string;
  footerClassName?: string;
};

export const OverlayContentWrapper = ({
  children,
  footer = null,
  contentClassName,
  footerClassName,
}: OverlayContentWrapperProps) => {
  const footerRef = useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = useState(0);

  useEffect(() => {
    if (footerRef.current) {
      setFooterHeight(footerRef.current.clientHeight || 0);
    }
  }, []);

  return (
    <div className="overlay-content-wrapper">
      <div
        className={cx('overlay-content-wrapper__content', contentClassName)}
        style={{paddingBottom: footerHeight + 16}}
      >
        {children}
      </div>
      {footer && (
        <div className={cx('overlay-content-wrapper__footer', footerClassName)} ref={footerRef}>
          {footer}
        </div>
      )}
    </div>
  );
};
